import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../common/SEO';
import Hero from './Hero';
import WhyChooseUs from './WhyChooseUs';
import ProcessSection from './ProcessSection';
import ServicesSection from './ServicesSection';
import PortfolioSection from './PortfolioSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';

/**
 * HomePage component
 * Combines all homepage sections into a complete page
 * Supports multiple languages through i18n
 * Includes enhanced SEO metadata and structured data
 */
const HomePage = () => {
  const { t } = useTranslation();
  
  // Structured data for the homepage
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": t('meta.title', 'Professional Translation Services'),
    "description": t('meta.description', 'Professional translation services for gaming, software, and technical content.'),
    "url": "https://natuxtranslations.com/",
    "mainEntity": {
      "@type": "Organization",
      "name": "Natux Translations",
      "url": "https://natuxtranslations.com"
    }
  };
  
  return (
    <>
      <SEO 
        title={t('meta.title', 'Professional Translation Services')}
        description={t('meta.description', 'Professional translation services for gaming, software, and technical content. High-quality localization services in multiple languages.')}
        schema={homeSchema}
      />
      
      <Hero />
      <WhyChooseUs />
      <ProcessSection />
      <ServicesSection />
      <PortfolioSection />
      <TestimonialsSection />
      <CTASection />
    </>
  );
};

export default HomePage;
